import React, { Component } from 'react'
import {
  getAuthManagerInstance,
  isLoggedIn,
  isInstitutional,
} from '../../../global/authentication/authentication-manager.js'
import {
  getContactArrayByType,
  moreMagicalSortingByTheInternalExternalUserStuff,
} from './whole-sale-sorter.js'
import { isLocal } from '../../../spa/utility'
import { accessStorage } from '../../../spa/components/institutional/common/institutionalConfig.js'

class FooterWholesaler extends Component {
  constructor() {
    super()

    this.state = {
      wholeSalers: null,
    }
  }

  componentDidMount() {
    getAuthManagerInstance()
    if (isInstitutional()) {
      const RMInfo = accessStorage.getRMInfo()
      const RM_data = {
        preferredFirstNm: RMInfo?.name,
        emailId: RMInfo?.email,
        phoneNbr: RMInfo?.phone,
        titleCd: 'My Relationship Manager',
      }

      if (RM_data?.preferredFirstNm && RM_data?.emailId && RM_data?.phoneNbr) {
        this.setState({ wholeSalers: [RM_data] })
        document
          .getElementById('footer-default-content')
          .classList.add('u-hidden')
      } else {
        this.setState({ wholeSalers: [] })
      }
    } else {
      getAuthManagerInstance()
        .getProfileServiceBehaviorSubject()
        .subscribe((profile) => {
          const wholeSalers = this.getDisplayableWholeSalers(profile)
          if (wholeSalers && wholeSalers.length > 0) {
            this.setState({ wholeSalers })
            document
              .getElementById('footer-default-content')
              .classList.add('u-hidden')
          } else {
            this.setState({ wholeSalers: [] })
          }
        })
    }
  }

  getDisplayableWholeSalers = (profile) => {
    let wholeSalersToDisplay = []

    // start with primary
    if (profile) {
      const primarySalesContactInfo = getContactArrayByType(
        profile.salesContactByChannel,
        'Y'
      )

      if (primarySalesContactInfo && primarySalesContactInfo.length > 0) {
        // we need to sort the primaries...
        primarySalesContactInfo[0].salesContactInfo.sort(
          moreMagicalSortingByTheInternalExternalUserStuff
        )
        wholeSalersToDisplay =
          primarySalesContactInfo[0].salesContactInfo.slice(0)
      }

      return wholeSalersToDisplay
    }
  }

  getRenderedWholesaler = (wholeSaler, index) => {
    const {
      preferredFirstNm,
      preferredLastNm,
      titleCd,
      designationCd,
      phoneNbr,
      emailId,
      photoURL,
    } = wholeSaler

    return (
      <React.Fragment key={`footerWholeSaler` + index}>
        {!isInstitutional() && (
          <div className="u-sm-sizeFull u-md-size1of8 u-lg-size1of8 u-sm-marginBottom5gu u-sm-flex u-flexJustifyCenter">
            <img
              className="u-sm-size1of2 u-md-sizeFull u-lg-sizeFull"
              src={
                photoURL
                  ? photoURL
                  : '/binaries/content/gallery/cti-blog/imported/cti-blank-profile.jpg/cti-blank-profile.jpg'
              }
              alt={preferredFirstNm}
              data-qa-automation="wholesaler-image"
            />
          </div>
        )}
        <div
          className={`${
            index === 0
              ? `u-sm-marginBottom5gu ${
                  isInstitutional()
                    ? 'u-md-size6of12 u-lg-size6of12'
                    : 'u-md-size3of8 u-lg-size3of8 u-paddingHoriz4gu u-md-paddingHoriz4gu u-sm-paddingHoriz1gu'
                }`
              : 'u-md-size3of8 u-lg-size3of8 u-paddingHoriz2gu u-md-paddingHoriz2gu u-sm-paddingHoriz1gu'
          }`}
        >
          <div className="col-bottom-txt">
            <div className="bottom-txt">
              <h3
                className={`u-textSecondary u-textColorBrandDarker Footer-wholesalerTitle`}
              >
                {preferredFirstNm} {preferredLastNm}
                {designationCd && (
                  <React.Fragment>
                    , <span className="u-textColorWhite">{designationCd}</span>
                  </React.Fragment>
                )}
              </h3>
              <p className="u-marginBottom2gu Footer-wholesalerText">
                {titleCd}
              </p>
              <dl className="List List--definition">
                <div className="List-item u-decoBorderLight">
                  <dt className="List-itemLabel">
                    Speak with {preferredFirstNm}{' '}
                  </dt>
                  <dd className="List-itemValue u-textRight">
                    <a href={`tel:${phoneNbr}`} className="Link">
                      {phoneNbr}
                    </a>
                  </dd>
                </div>
                <div className="List-item u-decoBorderLight u-decoBorderResetTop">
                  <dt className="List-itemLabel">Email {preferredFirstNm} </dt>
                  <dd className="List-itemValue u-textRight u-flex u-flexAlignItemsCenter u-flexJustifyEnd">
                    <span className="Icon--material u-textSizeMsrp1 u-textColorBrand u-marginRight1gu">
                      mail
                    </span>
                    <a
                      className="Link Footer-wholesalerLink"
                      href={
                        isInstitutional()
                          ? `mailto:${emailId}`
                          : `/about-us/contact-us/sc/email?emailId=${emailId}`
                      }
                    >
                      Send a Message
                    </a>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  displayNoConsultantMessage = () => {
    if (isLoggedIn()) {
      document
        .getElementById('consultant-team-button')
        .classList.add('u-hidden')

      return (
        <div className="Footer-alert alert alert-info u-decoBackgroundWhite u-paddingLeft4gu u-paddingVert3gu u-marginTop1gu u-marginBottom5gu u-sizeConstrained">
          <p className="u-textColorOrange">
            <b>
              We&apos;re sorry. Your consultant team information is not
              available,{' '}
            </b>
            but we&apos;re still here to help. Please call the National Sales
            Desk at 800.426.3750 for assistance.
          </p>
        </div>
      )
    }
  }

  render() {
    const { wholeSalers } = this.state
    return (
      wholeSalers &&
      (wholeSalers.length > 0 ? (
        <div className="Grid u-marginTop2gu u-marginBottom4gu u-sizeConstrained u-paddingVert4gu">
          {/* {
            !isInstitutional() && (
              <h3 className="u-marginBottom6gu u-marginTop2gu u-textColorBrandDarker">
                My Consultant Team
              </h3>
            )
          } */}
          {wholeSalers.map((wholeSaler, index) => {
            return this.getRenderedWholesaler(wholeSaler, index)
          })}
          <div className="u-marginTop8gu u-sm-flex u-flexJustifyCenter">
            <a
              href={`${
                isInstitutional()
                  ? '/institutional/contact-us'
                  : '/about-us/contact-us/'
              }`}
              className="Link u-textColorBrandLight u-posRelative hover-underline-animation u-contactLink"
            >
              <div className="u-flex u-flexAlignItemsCenter">
                <div className="u-textSecondary u-textKernLoose">
                  View all contact options
                </div>
                <img
                  src={`${
                    isLocal() ? '/cti-site' : ''
                  }/webfiles/latest/assets/cti/images/icon_chevron_brand_light.svg`}
                  alt=""
                  style={{ transform: 'translateY(1px)' }}
                />
              </div>
            </a>
          </div>
        </div>
      ) : (
        <React.Fragment>{this.displayNoConsultantMessage()}</React.Fragment>
      ))
    )
  }
}

export default FooterWholesaler
